import { gql } from "@apollo/client";

export const QR_LIST_PERSON = gql`
  query GetPersonList(
    $paginationParams: BaseCollection!
    $personStatus: String
    $search: String
    $attachementIds: [String!]
  ) {
    QR_LIST_PERSON(
      paginationParams: $paginationParams
      personStatus: $personStatus
      search: $search
      attachementIds: $attachementIds
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          lastName
          firstName
          email
          status
        }
      }
    }
  }
`;

export const QR_LIST_ESTABLISHMENT = gql`
  query GetEstablishmentList(
    $paginationParams: BaseCollection!
    $organizationId: String!
    $userEmail: String
    $withRole: Boolean
  ) {
    QR_LIST_ESTABLISHMENT(
      paginationParams: $paginationParams
      organizationId: $organizationId
      userEmail: $userEmail
      withRole: $withRole
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          status
          userRole
          isOwner
          company {
            legalName
          }
        }
      }
    }
  }
`;
